// Client-side config — reads NEXT_PUBLIC_* environment variables baked in
// by next.config.js at build / dev-server start time.
function getConfig() {
  return {
    publicRuntimeConfig: {
      // Environment
      deploymentEnv: process.env.NEXT_PUBLIC_DEPLOYMENT_ENV,
      // Site base path / context
      basePath: process.env.NEXT_PUBLIC_BASE_PATH,
      // API base path
      apiProxyBasePath: process.env.NEXT_PUBLIC_API_PROXY_BASE_PATH,
      // SWR options
      swrDedupingInterval: process.env.NEXT_PUBLIC_SWR_DEDUPING_INTERVAL,
      swrRefreshInterval: process.env.NEXT_PUBLIC_SWR_REFRESH_INTERVAL,
      swrRevalidateOnFocus: process.env.NEXT_PUBLIC_SWR_REVALIDATE_ON_FOCUS === "true",
      // Auth
      nextAuthKeycloakProviderId: process.env.NEXT_PUBLIC_NEXT_AUTH_KEYCLOAK_PROVIDER_ID,
      nextAuthBasePath: process.env.NEXT_PUBLIC_NEXT_AUTH_BASE_PATH,
      researcherPassportUrl: process.env.NEXT_PUBLIC_RESEARCHER_PASSPORT_URL,
      myDashboardPath: process.env.NEXT_PUBLIC_MY_DASHBOARD_PATH,
      // App
      version: process.env.NEXT_PUBLIC_VERSION,
      webUrl: process.env.NEXT_PUBLIC_WEB_URL,
      sessionTimeoutInterval: process.env.NEXT_PUBLIC_SESSION_TIMEOUT_INTERVAL,
      tinyMCEApiKey: process.env.NEXT_PUBLIC_TINYMCE_API_KEY,
      staticCssFile: process.env.NEXT_PUBLIC_STATIC_CSS_FILE,
    },
  };
}

export default getConfig;
